// src/admin/pages/AdminAddProduct.js
import React, { useState, useContext, useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import AdminSidebar from "../AdminSidebar";
import AdminHeader from "../AdminHeader";
import { FaSave, FaArrowLeft, FaImage, FaPlus, FaTrash } from "react-icons/fa";
import { AdminLanguageContext } from "../context/AdminLanguageContext";
import {
  createAdminProduct,
  getAdminCategories,
  getAdminTags,
  createAdminTag,
} from "../../services/adminProducts.api";
import { uploadAdminFile } from "../../services/adminUpload.api";

function AdminAddProduct() {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const { lang } = useContext(AdminLanguageContext);
  const [showConfirm, setShowConfirm] = useState(false);
const [showToast, setShowToast] = useState(false);
  const [uploadingIndex, setUploadingIndex] = useState(null);

  const [selectedFileNames, setSelectedFileNames] = useState({});


  const TEXT = {
    EN: {
      back: "Back to Products",
      title: "Add New Product",
      error: "Please fill all required fields (marked with *).",
      basic: "Basic Info",
      publicId: "Public ID *",
      nameEn: "Name (EN) *",
      nameAr: "Name (AR)",
      seoSlug: "SEO Slug *",
      shortDesc: "Short Descriptions",
      shortDescEn: "Short desc (EN)",
      shortDescAr: "Short desc (AR)",
      desc: "Descriptions",
      descEn: "Description (EN)",
      descAr: "Description (AR)",
      pricing: "Pricing & Flags",
      materialEn: "Material (EN) *",
      materialAr: "Material (AR) *",
      heelHeight: "Heel Height (cm) *",
      price: "Base Price ($) *",
      flags: "Flags",
      bestseller: "Bestseller",
      new: "New",
      sale: "On Sale",
      salePercent: "Sale %",
      discountedPrice: "Discounted Price",
      categories: "Categories (multi-select) *",
      tags: "Tags (multi-select)",
      addTag: "Add new tag",
      tagLabelEn: "Tag label (EN)",
      tagLabelAr: "Tag label (AR)",
      createTag: "Create",
      creating: "Creating...",
      images: "Product Images",
      addImage: "Add Image",
      imgUrl: "Image URL *",
      altEn: "Alt (EN)",
      altAr: "Alt (AR)",
      sortOrder: "Sort order",
      remove: "Remove",
      cancel: "Cancel",
      save: "Save Product",
      saving: "Saving...",
      selectAtLeastOneCategory: "Select at least 1 category.",
    },
    AR: {
      back: "العودة إلى المنتجات",
      materialEn: "الخامة (إنجليزي) *",
      materialAr: "الخامة (عربي) *",
      heelHeight: "ارتفاع الكعب (سم) *",
      title: "إضافة منتج جديد",
      error: "يرجى تعبئة جميع الحقول المطلوبة (*).",
      basic: "المعلومات الأساسية",
      publicId: "المعرّف العام *",
      nameEn: "الاسم (إنجليزي) *",
      nameAr: "الاسم (عربي)",
      seoSlug: "SEO Slug *",
      shortDesc: "وصف قصير",
      shortDescEn: "وصف قصير (إنجليزي)",
      shortDescAr: "وصف قصير (عربي)",
      desc: "الوصف",
      descEn: "الوصف (إنجليزي)",
      descAr: "الوصف (عربي)",
      pricing: "السعر والخصائص",
      price: "السعر الأساسي ($) *",
      flags: "الخصائص",
      bestseller: "الأكثر مبيعاً",
      new: "جديد",
      sale: "تخفيض",
      salePercent: "نسبة التخفيض %",
      discountedPrice: "السعر بعد التخفيض",
      categories: "التصنيفات (متعدد) *",
      tags: "الوسوم (متعدد)",
      addTag: "إضافة وسم جديد",
      tagLabelEn: "اسم الوسم (إنجليزي)",
      tagLabelAr: "اسم الوسم (عربي)",
      createTag: "إنشاء",
      creating: "جاري الإنشاء...",
      images: "صور المنتج",
      addImage: "إضافة صورة",
      imgUrl: "رابط الصورة *",
      altEn: "Alt (إنجليزي)",
      altAr: "Alt (عربي)",
      sortOrder: "ترتيب العرض",
      remove: "حذف",
      cancel: "إلغاء",
      save: "حفظ المنتج",
      saving: "جاري الحفظ...",
      selectAtLeastOneCategory: "اختر تصنيف واحد على الأقل.",
    },
  }[lang];

  // ------- meta lists -------
  const [allCategories, setAllCategories] = useState([]);
  const [allTags, setAllTags] = useState([]);

  // ------- product fields -------
  const [publicId, setPublicId] = useState("");
  const [nameEn, setNameEn] = useState("");
  const [nameAr, setNameAr] = useState("");
  const [seoSlug, setSeoSlug] = useState("");

  const [shortDescEn, setShortDescEn] = useState("");
  const [shortDescAr, setShortDescAr] = useState("");
  const [descEn, setDescEn] = useState("");
  const [descAr, setDescAr] = useState("");
  
  // NEW — product details
  const [materialEn, setMaterialEn] = useState("");
  const [materialAr, setMaterialAr] = useState("");
  const [heelHeight, setHeelHeight] = useState(""); 

  const [basePrice, setBasePrice] = useState("");
  const [onSale, setOnSale] = useState(false);
  const [salePercent, setSalePercent] = useState(0);
  const [isBestseller, setIsBestseller] = useState(false);
  const [isNewIn, setIsNewIn] = useState(false);

  // relations
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [selectedTags, setSelectedTags] = useState([]);

  // images
  const [images, setImages] = useState([
  {
    url: "",
    alt_en: "",
    alt_ar: "",
    color_name: "",
    sort_order: 1,
    media_type: "image", // ✅ default
  },
]);

  // tags accordion + create tag
  const [isTagsOpen, setIsTagsOpen] = useState(false);
  const [newTagEn, setNewTagEn] = useState("");
  const [newTagAr, setNewTagAr] = useState("");
  const [creatingTag, setCreatingTag] = useState(false);

  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);

  // -------- load categories + tags ----------
  useEffect(() => {
    let alive = true;

    Promise.all([getAdminCategories(), getAdminTags()])
      .then(([cats, tags]) => {
        if (!alive) return;
        setAllCategories(Array.isArray(cats) ? cats : []);
        setAllTags(Array.isArray(tags) ? tags : []);
      })
      .catch((e) => {
        console.error(e);
        if (alive) setError(e.message || "Error loading meta.");
      });

    return () => {
      alive = false;
    };
  }, []);

  // Sale UX: if off => percent 0
  useEffect(() => {
    if (!onSale) setSalePercent(0);
  }, [onSale]);

  const toggleIdInArray = (arr, idNum) => {
    const has = arr.includes(idNum);
    if (has) return arr.filter((x) => x !== idNum);
    return [...arr, idNum];
  };

  // -------- discounted price preview ----------
  const discountedPrice = useMemo(() => {
    if (!onSale || !basePrice || !salePercent) return "";
    const p = Number(basePrice);
    const d = p - (p * Number(salePercent)) / 100;
    return d.toFixed(2);
  }, [basePrice, salePercent, onSale]);

  // -------- images helpers ----------
  const addImageRow = () => {
  setImages((prev) => [
    ...(prev || []),
    {
      url: "",
      alt_en: "",
      alt_ar: "",
      color_name: "",
      sort_order: (prev?.length || 0) + 1,
      media_type: "image", // ✅ ADD THIS
    },
  ]);
};


  const removeImageRow = (idx) => {
    setImages((prev) => (prev || []).filter((_, i) => i !== idx));
  };

  const updateImageRow = (idx, patch) => {
    setImages((prev) =>
      (prev || []).map((img, i) => (i === idx ? { ...img, ...patch } : img))
    );
  };

  // -------- create new tag ----------
  const handleCreateTag = async () => {
    setError("");

    const en = newTagEn.trim();
    const ar = newTagAr.trim();

    if (!en) {
      setError(lang === "AR" ? "أدخل اسم الوسم (إنجليزي) على الأقل." : "Enter tag label (EN) at least.");
      return;
    }

    setCreatingTag(true);
    try {
      // backend will create slug
      const created = await createAdminTag({
        label_en: en,
        label_ar: ar,
      });

      // expected: { id, slug, label_en, label_ar }
      if (created?.id) {
        setAllTags((prev) => [created, ...(prev || [])]);
        setSelectedTags((prev) => toggleIdInArray(prev, Number(created.id)));
        setNewTagEn("");
        setNewTagAr("");
        setIsTagsOpen(true);
      }
    } catch (e) {
      console.error(e);
      setError(e.message || "Create tag error");
    } finally {
      setCreatingTag(false);
    }
  };

  // -------- submit ----------
  const handleConfirmSave = async () => {
  setError("");

  if (!publicId.trim() || !nameEn.trim() || basePrice === "" || Number(basePrice) < 0) {
    setError(TEXT.error);
    return;
  }

  if (!selectedCategories.length) {
    setError(TEXT.selectAtLeastOneCategory);
    return;
  }

  if (
  !materialEn.trim() ||
  !materialAr.trim() ||
  heelHeight === "" ||
  Number(heelHeight) < 0
) {
  setError(TEXT.error);
  return;
}


  const cleanedImages = (images || [])
  .map((img, idx) => ({
  url: String(img.url || "").trim(),
  alt_en: String(img.alt_en || "").trim(),
  alt_ar: String(img.alt_ar || "").trim(),
  color_name: String(img.color_name || "").trim(),
  sort_order: Number(img.sort_order ?? idx + 1),
  media_type: img.media_type || "image", // ✅ ignored by backend, safe
}))
    .filter((img) => img.url);

  if (!cleanedImages.length) {
    setError(lang === "AR" ? "أضف صورة واحدة على الأقل." : "Add at least 1 image.");
    return;
  }

  setSaving(true);
  try {
    await createAdminProduct({
      public_id: publicId.trim(),
      name_en: nameEn.trim(),
      name_ar: nameAr.trim(),
      material_en: materialEn.trim(),
      material_ar: materialAr.trim(),
      heel_height: Number(heelHeight),
      short_desc_en: shortDescEn.trim(),
      short_desc_ar: shortDescAr.trim(),
      description_en: descEn.trim(),
      description_ar: descAr.trim(),
      base_price: Number(basePrice).toFixed(2),
      on_sale: onSale,
      sale_percent: onSale ? Number(salePercent || 0) : 0,
      is_bestseller: isBestseller,
      is_new_in: isNewIn,
      seo_slug: seoSlug.trim(),
      categories: selectedCategories,
      tags: selectedTags,
      images: cleanedImages,
    });

    setShowToast(true);
    setTimeout(() => {
      navigate("/admin/products");
    }, 1200);
  } catch (err) {
    console.error(err);
    setError(err.message || "Save error");
  } finally {
    setSaving(false);
  }
};

const handleMultiImageUpload = async (files) => {
  if (!files || !files.length) return;

  const startOrder = images.length;

  for (let i = 0; i < files.length; i++) {
    const file = files[i];

    try {
      const uploaded = await uploadAdminFile(file);

      setImages((prev) => [
        ...prev,
        {
          url: uploaded.url,
          alt_en: "",
          alt_ar: "",
          color_name: "",
          sort_order: startOrder + i + 1,
          media_type: file.type?.startsWith("video/")
            ? "video"
            : "image",
        },
      ]);
    } catch (err) {
      alert(err.message || "Upload failed");
    }
  }
};


  return (
    <div className={`flex bg-gray-100 min-h-screen ${isOpen ? "overflow-hidden" : ""}`}>
      <AdminSidebar isOpen={isOpen} setIsOpen={setIsOpen} />

      <div className="flex-1 lg:ml-64 transition-all duration-300">
        <AdminHeader setIsOpen={setIsOpen} />

        <main className="p-4 sm:p-6 max-w-5xl">
          {/* Top bar */}
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-6">
            <button
              onClick={() => navigate("/admin/products")}
              className="flex items-center gap-2 px-4 py-2 rounded-xl bg-gray-200 hover:bg-gray-300"
            >
              <FaArrowLeft />
              {TEXT.back}
            </button>

            <h1 className="text-2xl font-bold text-cyan-700">{TEXT.title}</h1>
          </div>

          {error && (
            <div className="mb-4 p-3 rounded-lg bg-red-100 text-red-700 text-sm">
              {error}
            </div>
          )}

          {showToast && (
  <div className="fixed top-6 right-6 z-50 bg-green-600 text-white px-5 py-3 rounded-xl shadow-lg text-sm font-semibold animate-fade-in">
    ✅ Product created successfully
  </div>
)}


          {showConfirm && (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
    <div className="bg-white rounded-2xl shadow-xl p-6 w-full max-w-sm">
      <h3 className="text-lg font-bold text-gray-800 mb-2">
        Confirm Create
      </h3>

      <p className="text-sm text-gray-600 mb-6">
        Are you sure you want to create this product?
      </p>

      <div className="flex justify-end gap-3">
        <button
          type="button"
          onClick={() => setShowConfirm(false)}
          className="px-4 py-2 rounded-xl bg-gray-200 hover:bg-gray-300 text-sm"
        >
          Cancel
        </button>

        <button
          type="button"
          onClick={() => {
            setShowConfirm(false);
            handleConfirmSave();
          }}
          className="px-4 py-2 rounded-xl bg-cyan-600 text-white hover:bg-cyan-700 text-sm"
        >
          OK
        </button>
      </div>
    </div>
  </div>
)}


          <form
            onSubmit={(e) => {
    e.preventDefault();
    setShowConfirm(true);
  }}
            className="bg-white shadow-xl rounded-2xl p-6 border border-gray-200 space-y-6"
          >
            {/* BASIC INFO */}
            <section>
              <h2 className="text-lg font-semibold mb-3 text-gray-800">{TEXT.basic}</h2>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-semibold mb-1">{TEXT.publicId}</label>
                  <input
                    value={publicId}
                    onChange={(e) => setPublicId(e.target.value)}
                    className="w-full p-3 border rounded-xl focus:ring-2 focus:ring-cyan-400"
                  />
                </div>

                <div>
                  <label className="block text-sm font-semibold mb-1">{TEXT.seoSlug}</label>
                  <input
                    value={seoSlug}
                    onChange={(e) => setSeoSlug(e.target.value)}
                    className="w-full p-3 border rounded-xl focus:ring-2 focus:ring-cyan-400"
                    placeholder=""
                  />
                </div>

                <div>
                  <label className="block text-sm font-semibold mb-1">{TEXT.nameEn}</label>
                  <input
                    value={nameEn}
                    onChange={(e) => setNameEn(e.target.value)}
                    className="w-full p-3 border rounded-xl focus:ring-2 focus:ring-cyan-400"
                  />
                </div>

                <div>
                  <label className="block text-sm font-semibold mb-1">{TEXT.nameAr}</label>
                  <input
                    value={nameAr}
                    onChange={(e) => setNameAr(e.target.value)}
                    className="w-full p-3 border rounded-xl focus:ring-2 focus:ring-cyan-400"
                  />
                </div>

                <div>
  <label className="block text-sm font-semibold mb-1">
    {TEXT.materialEn}
  </label>
  <input
    value={materialEn}
    onChange={(e) => setMaterialEn(e.target.value)}
    className="w-full p-3 border rounded-xl focus:ring-2 focus:ring-cyan-400"
  />
</div>

<div>
  <label className="block text-sm font-semibold mb-1">
    {TEXT.materialAr}
  </label>
  <input
    value={materialAr}
    onChange={(e) => setMaterialAr(e.target.value)}
    className="w-full p-3 border rounded-xl focus:ring-2 focus:ring-cyan-400"
  />
</div>

<div>
  <label className="block text-sm font-semibold mb-1">
    {TEXT.heelHeight}
  </label>
  <input
    type="number"
    min="0"
    step="0.1"
    value={heelHeight}
    onChange={(e) => setHeelHeight(e.target.value)}
    className="w-full p-3 border rounded-xl focus:ring-2 focus:ring-cyan-400"
  />
</div>

              </div>
            </section>

            {/* SHORT DESC */}
            <section>
              <h2 className="text-lg font-semibold mb-3 text-gray-800">{TEXT.shortDesc}</h2>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <textarea
                  rows="3"
                  placeholder={TEXT.shortDescEn}
                  value={shortDescEn}
                  onChange={(e) => setShortDescEn(e.target.value)}
                  className="w-full p-3 border rounded-xl focus:ring-2 focus:ring-cyan-400"
                />
                <textarea
                  rows="3"
                  placeholder={TEXT.shortDescAr}
                  value={shortDescAr}
                  onChange={(e) => setShortDescAr(e.target.value)}
                  className="w-full p-3 border rounded-xl focus:ring-2 focus:ring-cyan-400"
                />
              </div>
            </section>

            {/* DESCRIPTIONS */}
            <section>
              <h2 className="text-lg font-semibold mb-3 text-gray-800">{TEXT.desc}</h2>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <textarea
                  rows="4"
                  placeholder={TEXT.descEn}
                  value={descEn}
                  onChange={(e) => setDescEn(e.target.value)}
                  className="w-full p-3 border rounded-xl focus:ring-2 focus:ring-cyan-400"
                />
                <textarea
                  rows="4"
                  placeholder={TEXT.descAr}
                  value={descAr}
                  onChange={(e) => setDescAr(e.target.value)}
                  className="w-full p-3 border rounded-xl focus:ring-2 focus:ring-cyan-400"
                />
              </div>
            </section>

            {/* PRICING + FLAGS */}
            <section>
              <h2 className="text-lg font-semibold mb-3 text-gray-800">{TEXT.pricing}</h2>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                <div>
                  <label className="block mb-1 text-sm font-semibold">{TEXT.price}</label>
                  <input
                    type="number"
                    value={basePrice}
                    onChange={(e) => setBasePrice(e.target.value)}
                    className="w-full p-3 border rounded-xl focus:ring-2 focus:ring-cyan-400"
                  />

                  <div className="mt-2">
                    <label className="block mb-1 text-xs font-semibold text-gray-500">
                      {TEXT.discountedPrice}
                    </label>
                    <input
                      type="text"
                      disabled
                      value={discountedPrice}
                      className={`w-full p-3 rounded-xl border text-sm font-semibold
                        ${onSale ? "text-red-600 bg-red-50" : "text-gray-400 bg-gray-100"}
                      `}
                      placeholder="—"
                    />
                  </div>
                </div>

                <div className="md:col-span-2 border rounded-xl p-4 bg-gray-50">
                  <div className="font-semibold mb-2 text-sm text-gray-700">{TEXT.flags}</div>

                  <div className="flex flex-wrap gap-4">
                    <label className="flex items-center gap-2 text-sm">
                      <input
                        type="checkbox"
                        checked={isBestseller}
                        onChange={(e) => setIsBestseller(e.target.checked)}
                      />
                      {TEXT.bestseller}
                    </label>

                    <label className="flex items-center gap-2 text-sm">
                      <input
                        type="checkbox"
                        checked={isNewIn}
                        onChange={(e) => setIsNewIn(e.target.checked)}
                      />
                      {TEXT.new}
                    </label>

                    <label className="flex items-center gap-2 text-sm">
                      <input
                        type="checkbox"
                        checked={onSale}
                        onChange={(e) => setOnSale(e.target.checked)}
                      />
                      {TEXT.sale}
                    </label>

                    <div className={`flex items-center gap-2 ${!onSale ? "opacity-50" : ""}`}>
                      <span className="text-sm">{TEXT.salePercent}</span>
                      <input
                        type="number"
                        min="0"
                        max="95"
                        disabled={!onSale}
                        value={salePercent}
                        onChange={(e) => setSalePercent(e.target.value)}
                        className="w-24 p-2 border rounded-lg focus:ring-2 focus:ring-cyan-400"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </section>

            {/* IMAGES */}
            <section>
              <div className="flex gap-2">
  {/* MULTI UPLOAD */}
  <input
    id="multi-image-upload"
    type="file"
    accept="image/*,video/*"
    multiple
    className="hidden"
    onChange={(e) => {
      const files = Array.from(e.target.files || []);
      handleMultiImageUpload(files);
      e.target.value = ""; // reset input
    }}
  />

  <label
    htmlFor="multi-image-upload"
    className="
      px-3 py-2 rounded-xl
      bg-cyan-600 text-white text-sm
      flex items-center gap-2
      hover:bg-cyan-700
      cursor-pointer
    "
  >
    <FaImage /> Upload Images
  </label>

  {/* OLD SINGLE ADD (KEEP IT) */}
  <button
    type="button"
    onClick={addImageRow}
    className="
      px-3 py-2 rounded-xl
      bg-gray-200 text-gray-800 text-sm
      flex items-center gap-2
      hover:bg-gray-300
    "
  >
    <FaPlus /> {TEXT.addImage}
  </button>
</div>


              <div className="space-y-3">
                {images.map((img, idx) => (
                  <div key={idx} className="border rounded-2xl p-4 bg-gray-50">
                    <div className="grid grid-cols-1 md:grid-cols-12 gap-3 items-start">
                      <div className="md:col-span-6">
                        <label className="block text-xs font-semibold text-gray-500 mb-1">
                          {TEXT.imgUrl}
                        </label>
                        <div className="flex flex-col gap-2">
  <input
    id={`img-upload-${idx}`}
    type="file"
    accept="image/*,video/*"
    className="hidden"
    onChange={async (e) => {
      const file = e.target.files?.[0];
      if (!file) return;

      setSelectedFileNames((prev) => ({ ...prev, [idx]: file.name }));

      setUploadingIndex(idx);
      try {
        const uploaded = await uploadAdminFile(file);

        updateImageRow(idx, {
          url: uploaded.url,
          media_type: file.type?.startsWith("video/") ? "video" : "image",
        });
      } catch (err) {
        alert(err.message || "Upload failed");
      } finally {
        setUploadingIndex(null);
      }
    }}
  />

  <label
    htmlFor={`img-upload-${idx}`}
    className={`
      inline-flex items-center justify-center gap-2
      px-4 py-3 rounded-xl
      border border-gray-300
      bg-white hover:bg-gray-50
      text-sm font-semibold text-gray-800
      shadow-sm
      cursor-pointer
      active:scale-[0.99]
      transition
      ${uploadingIndex === idx ? "opacity-60 pointer-events-none" : ""}
    `}
  >
    <FaImage className="text-gray-500" />
    {uploadingIndex === idx ? "Uploading..." : "Upload file"}
  </label>

  <div className="text-xs text-gray-500">
    {img.url
      ? "Uploaded ✅"
      : selectedFileNames[idx]
      ? selectedFileNames[idx]
      : "PNG, JPG, WEBP, MP4…"}
  </div>
</div>

                      </div>

                      <div className="md:col-span-2">
                        <label className="block text-xs font-semibold text-gray-500 mb-1">
                          {TEXT.sortOrder}
                        </label>
                        <input
                          type="number"
                          value={img.sort_order}
                          onChange={(e) =>
                            updateImageRow(idx, { sort_order: Number(e.target.value || 0) })
                          }
                          className="w-full p-3 border rounded-xl focus:ring-2 focus:ring-cyan-400"
                        />
                      </div>

                      <div className="md:col-span-4 flex justify-end">
                        <button
                          type="button"
                          onClick={() => removeImageRow(idx)}
                          className="px-3 py-2 rounded-xl bg-red-50 hover:bg-red-100 text-red-700 text-sm flex items-center gap-2"
                        >
                          <FaTrash /> {TEXT.remove}
                        </button>
                      </div>

                      <div className="md:col-span-6">
                        <label className="block text-xs font-semibold text-gray-500 mb-1">
                          {TEXT.altEn}
                        </label>
                        <input
                          value={img.alt_en}
                          onChange={(e) => updateImageRow(idx, { alt_en: e.target.value })}
                          className="w-full p-3 border rounded-xl focus:ring-2 focus:ring-cyan-400"
                        />
                      </div>

                      <div className="md:col-span-6">
                        <label className="block text-xs font-semibold text-gray-500 mb-1">
                          {TEXT.altAr}
                        </label>
                        <input
                          value={img.alt_ar}
                          onChange={(e) => updateImageRow(idx, { alt_ar: e.target.value })}
                          className="w-full p-3 border rounded-xl focus:ring-2 focus:ring-cyan-400"
                        />
                      </div>

                      <div className="md:col-span-6">
  <label className="block text-xs font-semibold text-gray-500 mb-1">
    Image Color (optional)
  </label>
  <input
    value={img.color_name || ""}
    onChange={(e) =>
      updateImageRow(idx, { color_name: e.target.value })
    }
    placeholder="e.g. Black, White, Red"
    className="w-full p-3 border rounded-xl focus:ring-2 focus:ring-cyan-400"
  />
</div>


                      <div className="md:col-span-12">
                       <div className="border rounded-xl bg-white p-3 flex flex-col items-center justify-center min-h-[110px] gap-2">
  {uploadingIndex === idx && (
    <div className="text-xs text-cyan-600 font-semibold">
      Uploading...
    </div>
  )}

  {img.url ? (
  img.media_type === "video" ||
  /\.(mp4|webm|ogg)$/i.test(img.url) ? (
    <video
  key={img.url}
  controls
  muted
  playsInline
  preload="metadata"
  className="w-32 h-24 object-contain rounded"
>
  <source src={img.url} type="video/mp4" />
</video>
  ) : (
    <img
      src={img.url}
      alt="Preview"
      className="w-24 h-24 object-contain rounded"
    />
  )
) : (
  <FaImage className="text-gray-300 text-3xl" />
)}

</div>

                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </section>

            {/* CATEGORIES MULTI-SELECT */}
            <section>
              <h2 className="text-lg font-semibold mb-3 text-gray-800">{TEXT.categories}</h2>

              <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-2">
                {allCategories.map((c) => {
                  const cid = Number(c.id);
                  const checked = selectedCategories.includes(cid);

                  return (
                    <label
                      key={c.id}
                      className={`flex items-center gap-2 p-2 rounded-xl border cursor-pointer text-sm
                        ${checked ? "bg-cyan-50 border-cyan-300" : "bg-white hover:bg-gray-50"}
                      `}
                    >
                      <input
  type="checkbox"
  checked={checked}
  onChange={() =>
    setSelectedCategories((prev) => toggleIdInArray(prev, cid))
  }
/>

                      <span className="truncate">{c.slug}</span>
                    </label>
                  );
                })}
              </div>
            </section>

            {/* TAGS MULTI-SELECT (ACCORDION + CREATE) */}
            <section className="border rounded-xl overflow-hidden">
              <button
                type="button"
                onClick={() => setIsTagsOpen((v) => !v)}
                className="w-full flex items-center justify-between px-4 py-3 bg-gray-50 hover:bg-gray-100 text-left"
              >
                <h2 className="text-lg font-semibold text-gray-800">{TEXT.tags}</h2>
                <span className="text-sm text-gray-500">{isTagsOpen ? "−" : "+"}</span>
              </button>

              {isTagsOpen && (
                <div className="p-4 space-y-4">
                  {/* create new tag */}
                  <div className="border rounded-xl p-3 bg-white">
                    <div className="text-sm font-semibold text-gray-700 mb-2">{TEXT.addTag}</div>

                    <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                      <input
                        value={newTagEn}
                        onChange={(e) => setNewTagEn(e.target.value)}
                        placeholder={TEXT.tagLabelEn}
                        className="w-full p-3 border rounded-xl focus:ring-2 focus:ring-cyan-400"
                      />
                      <input
                        value={newTagAr}
                        onChange={(e) => setNewTagAr(e.target.value)}
                        placeholder={TEXT.tagLabelAr}
                        className="w-full p-3 border rounded-xl focus:ring-2 focus:ring-cyan-400"
                      />
                      <button
                        type="button"
                        onClick={handleCreateTag}
                        disabled={creatingTag}
                        className="px-4 py-2 rounded-xl bg-cyan-600 text-white hover:bg-cyan-700 disabled:opacity-60"
                      >
                        {creatingTag ? TEXT.creating : TEXT.createTag}
                      </button>
                    </div>
                  </div>

                  {/* tags grid */}
                  <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-2">
                    {allTags.map((t) => {
                      const tid = Number(t.id);
                      const checked = selectedTags.includes(tid);

                      return (
                        <label
                          key={t.id}
                          className={`flex items-center gap-2 p-2 rounded-xl border cursor-pointer text-sm
                            ${checked ? "bg-gray-100 border-gray-300" : "bg-white hover:bg-gray-50"}
                          `}
                        >
                          <input
                            type="checkbox"
                            checked={checked}
                            onChange={() => setSelectedTags((prev) => toggleIdInArray(prev, tid))}
                          />
                          <span className="truncate">#{t.slug}</span>
                        </label>
                      );
                    })}
                  </div>

                  {selectedTags.length > 0 && (
                    <div className="flex flex-wrap gap-2">
                      {selectedTags.map((tid) => {
                        const found = allTags.find((x) => Number(x.id) === tid);
                        return (
                          <span
                            key={tid}
                            className="text-xs bg-gray-200 text-gray-800 px-2 py-1 rounded-full"
                          >
                            #{found ? found.slug : `#${tid}`}
                          </span>
                        );
                      })}
                    </div>
                  )}
                </div>
              )}
            </section>

            {/* BUTTONS */}
            <div className="flex justify-end gap-3 pt-4">
              <button
                type="button"
                onClick={() => navigate("/admin/products")}
                className="px-4 py-2 rounded-xl bg-gray-200 hover:bg-gray-300"
              >
                {TEXT.cancel}
              </button>

              <button
                type="submit"
                disabled={saving}
                className="px-5 py-2 rounded-xl bg-cyan-600 text-white flex items-center gap-2 hover:bg-cyan-700 disabled:opacity-60"
              >
                <FaSave />
                {saving ? TEXT.saving : TEXT.save}
              </button>
            </div>
          </form>
        </main>
      </div>
    </div>
  );
}

export default AdminAddProduct;
